<template>
    <Breadcrumbs
        main="Liste des sujets de notification"
        mains="Liste des sujets de notification"
        title="Paramètres"
    />
    <div class="container-fluid">
        <div class="row">
            <NotificationTopicList />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const NotificationTopicList = defineAsyncComponent(
    () => import('@/components/theme/notification/NotificationTopicList.vue'),
);
</script>